const wavesurfers = [];

function stopAllExcept(target) {
  wavesurfers.forEach((wavesurfer, index) => {    
    currentElement = target.closest("[class^='waveform--']");
    // currentElement.querySelector('.play-button').click();

    if (wavesurfer.container !== currentElement && wavesurfer.isPlaying()) {
      wavesurfer.pause();
    }
      
  });
}